import { useContext, useEffect, useState } from "react";
import css from "../css/view-modal.module.css";
import { FaTimes as CancelIcon } from "react-icons/fa";
import img from "../../../../images/default.png";

import { useQueries, useQuery } from "@tanstack/react-query";
import styled from "@emotion/styled";
import { FetchSingleData } from "../../../../hooks/FetchData";
import apiCall from "../../../../utils/apiCall";
import QualificationDiv from "../../ApplicantDetails/EducationalQualifications";
import PersonalDetails from "../../ApplicantDetails/PersonalDetails";
import { CircularProgress } from "@mui/material";
import { AxiosError } from "axios";
import HrStrategies from "../../ApplicantDetails/HrStrategies";
import WorkExperience from "../../ApplicantDetails/WorkExperience";
import NextOfKin from "../../ApplicantDetails/NextOfKin";
import ProfessionalBody from "../../ApplicantDetails/ProfessionalBody";
import HRTraining from "../../ApplicantDetails/HrTraining";
import CorporateDetails from "../../ApplicantDetails/CorporateDetails";
import TopManagement from "../../ApplicantDetails/TopManagementDetails";
import CorporateUpload from "../../ApplicantDetails/CorporateUpload";
import {
  PrRoute,
  ExRoute,
  AcRoute,
  MiRoute,
  CoRoute,
  MiRouteB,
  AcRouteB,
} from "../../../../utils/allRouteId";
import {
  RefereeData,
  ReferenceData,
  JobHistoryDetails,
  PersonalDetailsData,
  HRStrategiesDetails,
  HrTrainingDetails,
  ProfessionalBodyData,
  CoreHRExperienceDetails,
  CVDetails,
  CurrentEmployerDetails,
  NyscDischargeCertDetails,
  Countries,
  States,
  LGAs,
  Zone,
  TopManagementDetails,
  CorporateBioData,
  CorporateUploadDetails,
} from "../../ApplicantDetails/type";
import Button from "../../../../customs/Button";
import { ApprovalContext } from "../Approve/Approvals";
import { getAllQualification } from "../../../../api/applicantApi";

const ViewDetails = (props: any) => {
  const data = props.data;
  const onChange = props.onChange;

  // This is the key: If showActions is explicitly passed as false, we lock it.
  // Otherwise (in your main view), it stays 'false', meaning editing is ALLOWED.
  const isReadOnly = props.showActions === false;
  
  const [nextOfKin, setNextOfKin] = useState<any>({});

  const { setShowModal, setModalView } = useContext(ApprovalContext);

  // const AppMemberId = data?.ApplicantId || data.AppMemberId;
 const AppMemberId = data?.ApplicantId || data?.AppMemberId;
  const routeId = data?.RouteId;

  const {
    data: allQualification,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["get-all-qualification"],
    queryFn: async () => await getAllQualification(AppMemberId),
    select: (data) => data,
  });

  const allQualificationData = allQualification?.Data;

  const errorQualificationsAxios = error as AxiosError;

  const {
    data: tempNext,
    isLoading: nextLoading,
    isError: nextError,
  } = FetchSingleData(
    "profBody",
    `api/Applicant/GetNextOfKinByApplicantId?applicantId=${AppMemberId}`
  );

  const getJobHistoryDetails = async (): Promise<JobHistoryDetails[]> => {
    return (
      await apiCall().get(
        `/Applicant/GetJobHistoryById?applicantId=${AppMemberId}`
      )
    ).data?.Data as JobHistoryDetails[];
  };

  const getAllProfBodyDetails = async (): Promise<ProfessionalBodyData[]> => {
    return (
      await apiCall().get(
        `/Applicant/GetProfBodyByApplicantId?applicantId=${AppMemberId}`
      )
    ).data?.Data as ProfessionalBodyData[];
  };

  const getAllHrTrainingDetails = async (): Promise<HrTrainingDetails[]> => {
    return (
      await apiCall().get(
        `/Applicant/GetHRTrainingByApplicantId?ApplicantId=${AppMemberId}`
      )
    ).data?.Data as HrTrainingDetails[];
  };

  const getAllRefereeDetails = async (): Promise<RefereeData[]> => {
    return (
      await apiCall().get(
        `/Applicant/GetRefereeByApplicantId?ApplicantId=${AppMemberId}`
      )
    ).data?.Data as RefereeData[];
  };

   const getReferenceDetails = async (): Promise<ReferenceData[]> => {
    return (
      await apiCall().get(
        `/Applicant/getreferencebyapplicantid?ApplicantId=${AppMemberId}`
      )
    ).data?.Data as RefereeData[];
  };

  const getAllPersonalDetails = async (): Promise<PersonalDetailsData> => {
    return (
      await apiCall().get(
        `/Applicant/GetBioDataByApplicantId?applicantId=${AppMemberId}`
      )
    ).data?.Data as PersonalDetailsData;
  };

  const getCv = async (): Promise<CVDetails[]> => {
    return (
      await apiCall().get(
        `/Applicant/GetUploadCvApplicantId?applicantId=${AppMemberId}`
      )
    ).data?.Data as CVDetails[];
  };

  const getCoreHrExperience = async (): Promise<CoreHRExperienceDetails[]> => {
    return (
      await apiCall().get(
        `/Applicant/GetCoreHrByApplicantId?ApplicantId=${AppMemberId}`
      )
    ).data?.Data as CoreHRExperienceDetails[];
  };

  const getCurentEmployerInformation = async (): Promise<
    CurrentEmployerDetails[]
  > => {
    return (
      await apiCall().get(`/Applicant/GetCurrentJob?applicantId=${AppMemberId}`)
    ).data?.Data as CurrentEmployerDetails[];
  };

  const getNyscDischargeCert = async (): Promise<NyscDischargeCertDetails> => {
    return (
      await apiCall().get(
        `/Applicant/GetNyscDischargeByApplicantId?applicantId=${AppMemberId}`
      )
    ).data?.Data as NyscDischargeCertDetails;
  };

  const getHrStrategies = async (): Promise<HRStrategiesDetails[]> => {
    return (
      await apiCall().get(
        `/Applicant/GetHRStrategyByApplicantId?ApplicantId=${AppMemberId}`
      )
    ).data?.Data as HRStrategiesDetails[];
  };

  const getCountries = async (): Promise<Countries[]> => {
    return (await apiCall().get(`/Country/GetCountrys`)).data as Countries[];
  };

  const getStates = async (): Promise<States[]> => {
    return (await apiCall().get(`/State/GetAllStates`)).data as States[];
  };

  const getLGAs = async (): Promise<LGAs[]> => {
    return (await apiCall().get(`/LGA/GetAllLGAs`)).data as LGAs[];
  };

  const getZones = async (): Promise<Zone[]> => {
    return (await apiCall().get(`/Zone/GetZones`)).data as Zone[];
  };

  const getCorporateUpload = async (): Promise<CorporateUploadDetails[]> => {
    return (
      await apiCall().get(
        `/Applicant/FetchCorporateUploadByApplicantId?applicantId=${AppMemberId}`
      )
    ).data?.Data as CorporateUploadDetails[];
  };

  const getTopManagement = async (): Promise<TopManagementDetails> => {
    return (
      await apiCall().get(
        `/Applicant/GetTopManagementByApplicantId?applicantId=${AppMemberId}`
      )
    ).data?.Data as TopManagementDetails;
  };

  const getCorporateBioData = async (): Promise<CorporateBioData> => {
    return (
      await apiCall().get(
        `/Applicant/GetCorporateBioDataByApplicantId?applicantId=${AppMemberId}`
      )
    ).data?.Data as CorporateBioData;
  };

  const [
    getAllPersonalDetailsQuery,
    getAllRefereeDetailsQuery,
    getreferenceDetailsQuery,
    getAllHrTrainingDetailsQuery,
    getAllProfBodyDetailsQuery,
    getJobHistoryDetailsQuery,
    getCvQuery,
    getCoreHrExperienceQuery,
    getCurentEmployerInformationQuery,
    getNyscDischargeCertQuery,
    getHrStrategiesQuery,
    getCountryQuery,
    getStateQuery,
    getLGAQuery,
    getZonesQuery,
    getCorporateUploadQuery,
    getTopManagementQuery,
    getCorporateBioDataQuery,
  ] = useQueries({
    queries: [
      {
        queryKey: ["get-all-personal-details", AppMemberId],
        queryFn: getAllPersonalDetails,
        retry: 0,
      },
      {
        queryKey: ["get-all-referee-details", AppMemberId],
        queryFn: getAllRefereeDetails,
        retry: 0,
      },
       {
        queryKey: ["get-reference-details", AppMemberId],
        queryFn: getReferenceDetails,
        retry: 0,
      },
      {
        queryKey: ["get-all-hrTrainings-details", AppMemberId],
        queryFn: getAllHrTrainingDetails,
        retry: 0,
      },
      {
        queryKey: ["get-all-profBody-details", AppMemberId],
        queryFn: getAllProfBodyDetails,
        retry: 0,
      },
      {
        queryKey: ["get-all-jobHistory-details", AppMemberId],
        queryFn: getJobHistoryDetails,
        retry: 0,
      },
      { queryKey: ["get-CV", AppMemberId], queryFn: getCv, retry: 0 },
      {
        queryKey: ["get-all-CoreHrExperirnce-details", AppMemberId],
        queryFn: getCoreHrExperience,
        retry: 0,
      },
      {
        queryKey: ["get-all-currentEmployer-details", AppMemberId],
        queryFn: getCurentEmployerInformation,
        retry: 0,
      },
      {
        queryKey: ["get-nyscDischargeCert-details", AppMemberId],
        queryFn: getNyscDischargeCert,
        retry: 0,
      },
      {
        queryKey: ["get-hrStrategies-details", AppMemberId],
        queryFn: getHrStrategies,
        retry: 0,
      },
      {
        queryKey: ["get-countries", AppMemberId],
        queryFn: getCountries,
        retry: 0,
      },
      { queryKey: ["get-states", AppMemberId], queryFn: getStates, retry: 0 },
      { queryKey: ["get-LGAs", AppMemberId], queryFn: getLGAs, retry: 0 },
      { queryKey: ["get-Zones", AppMemberId], queryFn: getZones, retry: 0 },
      {
        queryKey: ["get-Corporate", AppMemberId],
        queryFn: getCorporateUpload,
        retry: 0,
      },
      {
        queryKey: ["get-Top-Management", AppMemberId],
        queryFn: getTopManagement,
        retry: 0,
      },
      {
        queryKey: ["get-Corporate-Biodata", AppMemberId],
        queryFn: getCorporateBioData,
        retry: 0,
      },
    ],
  });

  const personalDetailsData = getAllPersonalDetailsQuery?.data;
  const personalDetailsError = getAllPersonalDetailsQuery.error as AxiosError;
  const personalDetailsLoading = getAllPersonalDetailsQuery?.isLoading;

  const refreeDetailsData = getAllRefereeDetailsQuery?.data;
  const referenceDetailsData = getreferenceDetailsQuery?.data;

  const hrTrainingData = getAllHrTrainingDetailsQuery?.data;

  const profBodyData = getAllProfBodyDetailsQuery?.data;
  const profBodyError = getAllProfBodyDetailsQuery?.error as AxiosError;

  const jobHistoryData = getJobHistoryDetailsQuery?.data;
  const jobDetailsError = getJobHistoryDetailsQuery?.error as AxiosError;

  const CvData = getCvQuery?.data;
  const coreHrExperienceData = getCoreHrExperienceQuery?.data;
  const currentEmployerData = getCurentEmployerInformationQuery?.data;
  const nyscDischargeCertData = getNyscDischargeCertQuery?.data;

  const hrStrategiesData = getHrStrategiesQuery?.data;
  const hrStrategiesError = getHrStrategiesQuery?.error as AxiosError;

  const countryData = getCountryQuery?.data;
  const stateData = getStateQuery?.data;
  const lgaData = getLGAQuery?.data;
  const zoneData = getZonesQuery?.data;

  const corporateUploadData = getCorporateUploadQuery?.data;
  const coporateUploadError = getCorporateUploadQuery?.error as AxiosError;

  const topManagementData = getTopManagementQuery?.data;
  const topManagementError = getTopManagementQuery?.error as AxiosError;

  const getCorporateData = getCorporateBioDataQuery?.data;
  const getCorporateError = getCorporateBioDataQuery?.error as AxiosError;  

  const handleApproveOrDecline = () => {
    setModalView("approve");
    setShowModal(true);
  };

  useEffect(() => {
    if (!nextLoading && tempNext) {
      setNextOfKin(tempNext.Data);
    }
  }, [tempNext, nextLoading, nextError]);
  

  return (
   <div className={css.container}>
      {/* 1. Header and Close Icon remain active */}
      <span className={css.cancel} onClick={() => onChange(false)}>
        <CancelIcon />
      </span>

      <div className={css.firstDiv}>
        {personalDetailsLoading ? (
          <CircularProgress
            sx={{
              fontSize: "1rem",
              marginInline: "auto",
              display: "block",
              marginBlock: "2rem",
            }}
          />
        ) : (
          <div>
            <img
              src={
                personalDetailsData?.UploadPictureUrl
                  ? personalDetailsData?.UploadPictureUrl
                  : img
              }
              style={{
                objectFit: "contain",
                width: "116px",
                height: "109px",
                borderRadius: "3px",
              }}
              alt=""
            />

            <div>
              <span>{`${personalDetailsData?.FirstName} ${personalDetailsData?.LastName} ${personalDetailsData?.MiddleName}`}</span>

              <span className={"applicant-Id"}>
                {personalDetailsData?.ApplicantId || data?.AppMemberId}
              </span>

              <span>{data?.RouteName}</span>
            </div>
          </div>
        )}

        <div>
          <span>Total Score</span>
          <span>{personalDetailsData?.TotalScore || 0} points</span>
        </div>
      </div>

<div className={`${css.secondDiv} ${isReadOnly ? css.lockInteractions : ''}`}><div></div>

        <div className={css.contentDiv}>
          {data?.RouteId === Number(CoRoute) ? (
            <>
              {/* showIndex == 0 ? */}
              {getCorporateBioDataQuery?.isLoading ? (
                <CircularProgress
                  sx={{
                    fontSize: "1rem",
                    marginInline: "auto",
                    display: "block",
                    marginBlock: "2rem",
                  }}
                />
              ) : getCorporateBioDataQuery?.isError ? (
                <StyledError>{getCorporateError?.message}</StyledError>
              ) : (
                <CorporateDetails data={getCorporateData} referenceData={referenceDetailsData ?? []} />
              )}
              {/* : showIndex == 1 ? */}
              {getTopManagementQuery?.isLoading ? (
                <CircularProgress
                  sx={{
                    fontSize: "1rem",
                    marginInline: "auto",
                    display: "block",
                    marginBlock: "2rem",
                  }}
                />
              ) : getTopManagementQuery?.isError ? (
                <StyledError>{topManagementError?.message}</StyledError>
              ) : (
                <TopManagement data={topManagementData} />
              )}
              :
              {getCorporateUploadQuery?.isLoading ? (
                <CircularProgress
                  sx={{
                    fontSize: "1rem",
                    marginInline: "auto",
                    display: "block",
                    marginBlock: "2rem",
                  }}
                />
              ) : getCorporateUploadQuery?.isError ? (
                <StyledError>{coporateUploadError?.message}</StyledError>
              ) : (
                <CorporateUpload
                  data={corporateUploadData}
                  applicantId={AppMemberId}
                />
              )}
            </>
          ) : (
            <>
              {/* { showIndex == 0 ? */}
              {getAllPersonalDetailsQuery?.isLoading ? (
                <CircularProgress
                  sx={{
                    fontSize: "1rem",
                    marginInline: "auto",
                    display: "block",
                    marginBlock: "2rem",
                  }}
                />
              ) : getAllPersonalDetailsQuery?.isError ? (
                <StyledError>{personalDetailsError?.message}</StyledError>
              ) : (
                <PersonalDetails
                  data={personalDetailsData}
                  state={stateData}
                  country={countryData}
                  lga={lgaData}
                  zones={zoneData}
                  isReadOnly={isReadOnly}

                />
              )}
              {/* : showIndex == 1 ?  */}
              {isLoading && allQualificationData && nyscDischargeCertData ? (
                <CircularProgress
                  sx={{
                    fontSize: "1rem",
                    marginInline: "auto",
                    display: "block",
                    marginBlock: "2rem",
                  }}
                />
              ) : isError ? (
                <StyledError>{errorQualificationsAxios?.message}</StyledError>
              ) : (
                <QualificationDiv
                  handleCancel={onChange}
                  routeId={routeId}
                  data={allQualificationData || []}
                  isReadOnly={isReadOnly}
                  nyscDischargeCertData={
                    nyscDischargeCertData || ({} as NyscDischargeCertDetails)
                  }
                />
                // <QualificationDiv
                //   handleCancel={onChange}
                //   routeId={routeId}
                //   data={finalQ || []}
                //   nyscDischargeCertData={
                //     nyscDischargeCertData || ({} as NyscDischargeCertDetails)
                //   }
                // />
              )}
              {/* : showIndex == 2 ? */}
              {getJobHistoryDetailsQuery?.isLoading ? (
                <CircularProgress
                  sx={{
                    fontSize: "1rem",
                    marginInline: "auto",
                    display: "block",
                    marginBlock: "2rem",
                  }}
                />
              ) : getJobHistoryDetailsQuery?.isError ? (
                <StyledError>{jobDetailsError?.message}</StyledError>
              ) : (
                <WorkExperience
                  routeId={data?.RouteId}
                  routeName={data?.RouteName}
                  currentEmployerData={currentEmployerData}
                  workData={jobHistoryData}
                  refreeData={refreeDetailsData}
                  referenceData={referenceDetailsData}
                  isReadOnly={isReadOnly}
                />
              )}
              {/* : showIndex == 3 ? */}
              {getJobHistoryDetailsQuery?.isLoading ? (
                <CircularProgress
                  sx={{
                    fontSize: "1rem",
                    marginInline: "auto",
                    display: "block",
                    marginBlock: "2rem",
                  }}
                />
              ) : getJobHistoryDetailsQuery?.isError ? (
                <StyledError>{jobDetailsError?.message}</StyledError>
              ) : (
                <NextOfKin data={nextOfKin} />
              )}
              {/* :showIndex == 4 ? */}
              {getAllProfBodyDetailsQuery?.isLoading ? (
                <CircularProgress
                  sx={{
                    fontSize: "1rem",
                    marginInline: "auto",
                    display: "block",
                    marginBlock: "2rem",
                  }}
                />
              ) : getAllProfBodyDetailsQuery?.isError ? (
                <StyledError>{profBodyError?.message}</StyledError>
              ) : (
                <ProfessionalBody data={profBodyData} />
              )}
              {/* : showIndex == 5 ? */}
              {data?.RouteId == Number(MiRouteB) ||
              data?.RouteId === Number(MiRoute) ||
              data?.RouteId === Number(ExRoute) ||
              data?.RouteId === Number(AcRouteB) ||
              data?.RouteId === Number(AcRoute) ||
              data?.RouteId == Number(PrRoute) ? (
                <>
                  {getAllHrTrainingDetailsQuery?.isLoading ? (
                    <CircularProgress
                      sx={{
                        fontSize: "1rem",
                        marginInline: "auto",
                        display: "block",
                        marginBlock: "2rem",
                      }}
                    />
                  ) : getAllHrTrainingDetailsQuery?.isError ? (
                    <StyledError>{profBodyError?.message}</StyledError>
                  ) : (
                    <HRTraining
                      routeId={data?.RouteId}
                      researchWork={hrStrategiesData}
                      handleCancel={onChange}
                      hrTrainingData={hrTrainingData}
                      coreHrExperienceData={coreHrExperienceData}
                      CVData={CvData}
                      isReadOnly={isReadOnly}

                    />
                  )}
                </>
              ) : (
                <></>
              )}

              {data?.RouteId == Number(MiRouteB) ||
              data?.RouteId == Number(ExRoute) ||
              data?.RouteId == Number(AcRouteB) ? (
                <>
                  {getHrStrategiesQuery?.isLoading ? (
                    <CircularProgress
                      sx={{
                        fontSize: "1rem",
                        marginInline: "auto",
                        display: "block",
                        marginBlock: "2rem",
                      }}
                    />
                  ) : getHrStrategiesQuery?.isError ? (
                    <StyledError>{hrStrategiesError?.message}</StyledError>
                  ) : (
                    <HrStrategies
                      routeId={data?.RouteId}
                      handleCancel={onChange}
                      data={hrStrategiesData}
                      isReadOnly={isReadOnly}

                    />
                  )}
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </div>

   <div className={css.approvalBtn} style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <Button
            bg="#bd1212"
            text="Cancel"
            onClick={() => onChange(false)}
          />
          
          {/* This button ONLY appears in the main ViewDetails, never in the Report */}
          {!isReadOnly && (
            <Button
              bg="green"
              text="Decline/Approve"
              onClick={handleApproveOrDecline}
            />
          )}

      </div>
            </div>
          </div>
        );
      };
export default ViewDetails;

const StyledError = styled("p")`
  color: red;
  font-size: 1.4rem;
  display: flex;
`;
